import { useGeometryEditorStateContext } from '@cibo/mapgl'
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
import { Alert, Button, Stack, Typography } from '@mui/material'
import { Feature, MultiPolygon, Polygon } from 'geojson'
import { useTranslation } from 'react-i18next'

type AutofixButtonProps = {
  overlaps?: Feature<Polygon | MultiPolygon, { ownedByCurUser: boolean }>[]
}

export const AutofixButton = ({ overlaps }: AutofixButtonProps) => {
  const { t } = useTranslation('GeometryEditor')

  const { autofixOverlaps } = useGeometryEditorStateContext()

  if (!overlaps?.length) return null

  const overlapOwner = overlaps.find(({ properties }) => !properties.ownedByCurUser)
    ? 'other'
    : overlaps.find(({ properties }) => !!properties.ownedByCurUser)
    ? 'self'
    : 'unknown'

  return (
    <Alert severity={'warning'}>
      <Stack spacing={0.5}>
        <Typography>
          {t('overlapError', { context: overlapOwner, growerTitle: t('grower') })}
        </Typography>
        <Button
          variant="outlined"
          size="small"
          onClick={autofixOverlaps}
          startIcon={<AutoFixHighIcon />}
        >
          {t('autofix')}
        </Button>
      </Stack>
    </Alert>
  )
}
